import React from 'react'
import PropTypes from 'prop-types'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

import I18n from 'lib/i18n'

import MainMenu from '~/scenes/header/main-menu'
import SearchBox from '../search-box'
import ProfileMenu from './profile-menu'
import HeaderAction from './header-action'
import Logo from './logo'
import IconWithCount from './icon-with-count'
import Phone from './phone'

const HeaderElements = ({ auxAvatar, visiblerule, headerFavouritesCount, ...headerProps }) => {
  const {
    isLoggedIn,
    categorySuggestions,
    showSearchbox,
    favouritesCount,
    unreadMessageCount,
    coursesCount,
    avatar,
    teachPath,
    isRecruitmentPage,
    profileMenuItems,
    loginPath,
    signupPath,
    profilePath,
    favouritesPath,
    inboxPath,
    firstName
  } = headerProps

  // From the props or from a reducer if manually updated
  const totalFavouritesCount = !headerFavouritesCount ? favouritesCount : headerFavouritesCount

  const buttonTitle =
    isLoggedIn && coursesCount > 0 ? I18n.t('layouts.application.my_classes') : I18n.t('layouts.application.teach_long')

  return (
    <div className={`react-header ${visiblerule}`} data-attr='header-actions'>
      <MainMenu
        mainMenuId='header-main-menu'
        profilePath={profilePath}
        avatar={auxAvatar || avatar}
        firstName={firstName}
        isLoggedIn={isLoggedIn}
        loginPath={loginPath}
        signupPath={signupPath}
        coursesCount={coursesCount}
      />
      <LazyLoadComponent>
        <Logo isLoggedIn={isLoggedIn} showSearchbox={showSearchbox} />
      </LazyLoadComponent>
      {showSearchbox && <SearchBox categorySuggestions={categorySuggestions} />}
      <div className='header-right-elements'>
        {showSearchbox ? (
          <HeaderAction
            isButton
            hideUnder={isLoggedIn ? 810 : 961}
            isCentered={false}
            redirectUrl={teachPath}
            title={buttonTitle}
          />
        ) : (
          <HeaderAction
            isButton
            hideUnder={isRecruitmentPage ? (isLoggedIn ? 630 : 320) : 630}
            right
            redirectUrl={teachPath}
            title={buttonTitle}
          />
        )}
        {isLoggedIn ? (
          <>
            <ProfileMenu
              lastOnRight={showSearchbox}
              avatar={auxAvatar || avatar}
              menuItems={profileMenuItems.filter(item => !!item)}
            />
            <IconWithCount
              object={`notifications${unreadMessageCount > 0 ? ' active' : ''}`}
              count={unreadMessageCount}
              redirectLink={inboxPath}
              dataAttr='inbox-url'
            />
          </>
        ) : (
          <Phone lastOnRight={showSearchbox} />
        )}
        {totalFavouritesCount > 0 && (
          <IconWithCount object='favorites' count={totalFavouritesCount} redirectLink={favouritesPath} />
        )}
      </div>
    </div>
  )
}

export default HeaderElements

HeaderElements.propTypes = {
  isLoggedIn: PropTypes.bool,
  categorySuggestions: PropTypes.array,
  showSearchbox: PropTypes.bool,
  favouritesCount: PropTypes.number,
  unreadMessageCount: PropTypes.number,
  coursesCount: PropTypes.number,
  avatar: PropTypes.string,
  teachPath: PropTypes.string,
  isRecruitmentPage: PropTypes.bool,
  profileMenuItems: PropTypes.array,
  loginPath: PropTypes.string,
  signupPath: PropTypes.string,
  profilePath: PropTypes.string,
  favouritesPath: PropTypes.string,
  inboxPath: PropTypes.string,
  firstName: PropTypes.string,
  auxAvatar: PropTypes.string,
  visiblerule: PropTypes.string,
  headerFavouritesCount: PropTypes.bool
}
